export default "__VITE_ASSET__XefB0rfI__"